import { Box } from "@chakra-ui/react";
import React from "react";

const TrackLinkCard = ({ msg, link }) => {
  return (
    <Box>
      {msg}
      {"   "}
      <a href={link} style={{ color: "blue" }} target="_blank">
        Click Here
      </a>
    </Box>
  );
};
export default TrackLinkCard;
